import { User } from '@monorepo/utils/auth-types'
import { auth as firebaseAuth, firestore, onAuthStateChanged } from '@monorepo/utils/firebase'
import { collection, doc, getDoc, setDoc } from '@monorepo/utils/firebase'
import { log } from '@monorepo/utils/utils'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { signInAnonymously } from '../../utils'

const INITIAL_CREDITS = 100

export const useAuthChange = () => {
  const [user, setUser] = useState<User | null>(null)
  const dispatch = useDispatch()
  const onAuthChange = useCallback(
    async (user: User | null) => {
      // log('Auth state changed:', { uid: user?.uid, email: user?.email, isAnonymous: user?.isAnonymous })
      setUser(user)
      if (!user?.uid) {
        dispatch<any>(signInAnonymously())
        return
      }

      try {
        const document = doc(collection(firestore(), `users`), user.uid)
        const current = await getDoc(document)
        // log('User document exists:', current.exists())

        if (!current.exists()) {
          const data = {
            email: user.email,
            createdAt: new Date().toISOString(),
            lastLoginAt: new Date().toISOString(),
            isAnonymous: user.isAnonymous,
            credits: INITIAL_CREDITS,
          }
          await setDoc(document, data)
          log('User document created successfully:', data)
        } else {
          log('User document already exists')
        }
      } catch (error) {
        console.error('Failed to create or check user document:', error)
      }
    },
    [dispatch]
  )
  useEffect(() => {
    onAuthStateChanged(firebaseAuth(), onAuthChange)
  }, [onAuthChange])
  return user
}
